import { ref } from 'vue'

/** Mode de l'application, lu une fois sur /api/status au démarrage. */
export const maintenanceEnabled = ref(import.meta.env.VITE_MAINTENANCE_ENABLED === 'true')

let loaded: Promise<void> | null = null

export const loadMaintenanceStatus = (): Promise<void> => {
  if (!loaded) {
    loaded = fetch('/api/status', { credentials: 'include' })
      .then(r => r.json())
      .then(data => { if (data?.success) maintenanceEnabled.value = maintenanceEnabled.value || !!data.data.maintenance })
      .catch(() => { /* API injoignable : on garde la valeur du build */ })
  }
  return loaded
}
